(function () {
  var CONTAINER_ID = 'ProductGridContainer';
  var loading = false;
  var observer = null;
  var selfMutating = false;

  function getNextUrl() {
    var link = document.querySelector('#' + CONTAINER_ID + ' .pagination__item--next');
    return link ? link.href : null;
  }

  function getGrid() {
    return document.querySelector('#' + CONTAINER_ID + ' .collection__grid');
  }

  function removePagination() {
    selfMutating = true;
    var nav = document.querySelector('#' + CONTAINER_ID + ' .pagination');
    if (nav) nav.remove();
    selfMutating = false;
  }

  function createSentinel(nextUrl) {
    selfMutating = true;
    var old = document.getElementById('cro-scroll-sentinel');
    if (old) old.remove();
    if (!nextUrl) { selfMutating = false; return null; }

    var el = document.createElement('div');
    el.id = 'cro-scroll-sentinel';
    el.dataset.nextUrl = nextUrl;
    el.innerHTML = '<div class="cro-scroll-spinner" style="display:none"><div class="cro-spinner"></div></div>';
    document.getElementById(CONTAINER_ID).appendChild(el);
    selfMutating = false;
    return el;
  }

  function loadNextPage(sentinel) {
    if (loading) return;
    loading = true;

    var nextUrl = sentinel.dataset.nextUrl;
    var container = document.getElementById(CONTAINER_ID);
    var section = container ? container.closest('[data-section-id]') : null;
    if (!section) { loading = false; return; }

    var url = new URL(nextUrl, window.location.origin);
    url.searchParams.set('section_id', section.dataset.sectionId);

    var spinner = sentinel.querySelector('.cro-scroll-spinner');
    if (spinner) spinner.style.display = 'flex';

    fetch(url.toString())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.querySelector('#' + CONTAINER_ID + ' .collection__grid');
        if (!newGrid) { loading = false; return; }

        selfMutating = true;
        var grid = getGrid();
        var items = newGrid.querySelectorAll('.collection__grid-item');
        items.forEach(function (item) { grid.appendChild(item); });
        sentinel.remove();
        selfMutating = false;

        var newNext = doc.querySelector('.pagination__item--next');
        if (newNext) {
          var nextHref = newNext.getAttribute('href');
          var resolvedUrl = new URL(nextHref, window.location.origin).toString();
          var s = createSentinel(resolvedUrl);
          if (s) observeSentinel(s);
        }

        loading = false;
      })
      .catch(function () { loading = false; });
  }

  function observeSentinel(sentinel) {
    if (observer) observer.disconnect();
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          observer.disconnect();
          loadNextPage(sentinel);
        }
      });
    }, { rootMargin: '400px' });
    observer.observe(sentinel);
  }

  function init() {
    var grid = getGrid();
    if (!grid) return;

    var nextUrl = getNextUrl();
    removePagination();
    if (!nextUrl) return;

    // Only reset state when we actually have new pagination to process
    loading = false;
    if (observer) { observer.disconnect(); observer = null; }

    var sentinel = createSentinel(nextUrl);
    if (sentinel) observeSentinel(sentinel);
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after filter/sort AJAX replaces the grid (but not our own mutations)
  var container = document.getElementById(CONTAINER_ID);
  if (container) {
    new MutationObserver(function () {
      if (selfMutating) return;
      setTimeout(init, 150);
      // Re-observe social bars on newly loaded cards (mobile)
      setTimeout(observeSocialBars, 200);
    }).observe(container, { childList: true, subtree: true });
  }

  // --- Mobile: reveal social bars on scroll, then auto-fade ---
  // We observe the parent .product-card__media (not the bar itself)
  // because the bar has translateY(100%) which pushes it out of view.
  var revealObserver = null;

  function observeSocialBars() {
    if (window.innerWidth > 767) return;
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var bar = entry.target.querySelector('.cro-social-bar');
            if (bar) bar.classList.add('cro-social-reveal');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.3 });
    }
    var cards = document.querySelectorAll('.product-card__media:not(.cro-social-observed)');
    cards.forEach(function (card) {
      if (!card.querySelector('.cro-social-bar')) return;
      card.classList.add('cro-social-observed');
      revealObserver.observe(card);
    });
  }

  // Initial observe on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeSocialBars);
  } else {
    observeSocialBars();
  }

})();
